// Prefetch product listings on category link click so the request runs
// in parallel with page navigation instead of sequentially after it.
const plpPrefetchCache = new Map<string, any>();

export function prefetchPlpListing(apiClient: any, categoryId: string) {
    if (!categoryId || plpPrefetchCache.has(categoryId)) return;

    apiClient
        .invoke('readProductListing post /product-listing/{categoryId}', {
            headers: { 'sw-include-seo-urls': true },
            pathParams: { categoryId },
            body: { limit: 48, p: 1, includeSubcategories: true },
        })
        .then(({ data }: any) => {
            plpPrefetchCache.set(categoryId, data);
        })
        .catch(() => {
            // Prefetch failed — normal search will handle it
        });
}

export function consumePlpPrefetch(categoryId: string): any | undefined {
    if (!categoryId) return undefined;
    const data = plpPrefetchCache.get(categoryId);
    if (data) plpPrefetchCache.delete(categoryId);
    return data;
}
